// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__2ZjBf","header":"PatientQuestionnaire_header__aArlV","info":"PatientQuestionnaire_info__Fsfl1"};